function e(e, t) {
  if (t == null || t > e.length) t = e.length;
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function t(t) {
  if (Array.isArray(t)) return e(t);
}
function n(e, t, n, r, i, o, u) {
  try {
    var s = e[o](u);
    var c = s.value;
  } catch (e) {
    n(e);
    return;
  }
  if (s.done) {
    t(c);
  } else {
    Promise.resolve(c).then(r, i);
  }
}
function r(e) {
  return function () {
    var t = this,
      r = arguments;
    return new Promise(function (i, o) {
      var u = e.apply(t, r);
      function s(e) {
        n(u, i, o, s, c, "next", e);
      }
      function c(e) {
        n(u, i, o, s, c, "throw", e);
      }
      s(undefined);
    });
  };
}
function i(e, t, n) {
  if (t in e) {
    Object.defineProperty(e, t, {
      value: n,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    e[t] = n;
  }
  return e;
}
function o(e) {
  if (typeof Symbol !== "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function u() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function s(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    var r = Object.keys(n);
    if (typeof Object.getOwnPropertySymbols === "function") {
      r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
        return Object.getOwnPropertyDescriptor(n, e).enumerable;
      }));
    }
    r.forEach(function (t) {
      i(e, t, n[t]);
    });
  }
  return e;
}
function c(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    if (t) {
      r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      });
    }
    n.push.apply(n, r);
  }
  return n;
}
function a(e, t) {
  t = t != null ? t : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(e, Object.getOwnPropertyDescriptors(t));
  } else {
    c(Object(t)).forEach(function (n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function f(e) {
  return t(e) || o(e) || d(e) || u();
}
function l(e) {
  "@swc/helpers - typeof";

  return e && typeof Symbol !== "undefined" && e.constructor === Symbol ? "symbol" : typeof e;
}
function d(t, n) {
  if (!t) return;
  if (typeof t === "string") return e(t, n);
  var r = Object.prototype.toString.call(t).slice(8, -1);
  if (r === "Object" && t.constructor) r = t.constructor.name;
  if (r === "Map" || r === "Set") return Array.from(r);
  if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return e(t, n);
}
function p(e, t) {
  var n,
    r,
    i,
    o,
    u = {
      label: 0,
      sent: function () {
        if (i[0] & 1) throw i[1];
        return i[1];
      },
      trys: [],
      ops: []
    };
  return o = {
    next: s(0),
    "throw": s(1),
    "return": s(2)
  }, typeof Symbol === "function" && (o[Symbol.iterator] = function () {
    return this;
  }), o;
  function s(e) {
    return function (t) {
      return c([e, t]);
    };
  }
  function c(o) {
    if (n) throw new TypeError("Generator is already executing.");
    while (u) try {
      if (n = 1, r && (i = o[0] & 2 ? r["return"] : o[0] ? r["throw"] || ((i = r["return"]) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
      if (r = 0, i) o = [o[0] & 2, i.value];
      switch (o[0]) {
        case 0:
        case 1:
          i = o;
          break;
        case 4:
          u.label++;
          return {
            value: o[1],
            done: false
          };
        case 5:
          u.label++;
          r = o[1];
          o = [0];
          continue;
        case 7:
          o = u.ops.pop();
          u.trys.pop();
          continue;
        default:
          if (!(i = u.trys, i = i.length > 0 && i[i.length - 1]) && (o[0] === 6 || o[0] === 2)) {
            u = 0;
            continue;
          }
          if (o[0] === 3 && (!i || o[1] > i[0] && o[1] < i[3])) {
            u.label = o[1];
            break;
          }
          if (o[0] === 6 && u.label < i[1]) {
            u.label = i[1];
            i = o;
            break;
          }
          if (i && u.label < i[2]) {
            u.label = i[2];
            u.ops.push(o);
            break;
          }
          if (i[2]) u.ops.pop();
          u.trys.pop();
          continue;
      }
      o = t.call(e, u);
    } catch (e) {
      o = [6, e];
      r = 0;
    } finally {
      n = i = 0;
    }
    if (o[0] & 5) throw o[1];
    return {
      value: o[0] ? o[1] : void 0,
      done: true
    };
  }
}
import h from "qs";
var y = function (e) {
    return e !== null && typeof e == "object";
  },
  v = function (e) {
    return typeof e == "string";
  };
var m = function (e) {
  if (!y(e)) throw new Error("queries is not object");
  return h.stringify(e, {
    arrayFormat: "comma"
  });
};
var b = "microcms.io",
  w = "v1";
import q, { Headers as g } from "cross-fetch";
var I = function (e) {
    var t;
    return e ? t = e : (typeof fetch === "undefined" ? "undefined" : l(fetch)) > "u" ? t = q : t = fetch, function () {
      for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
        n[r] = arguments[r];
      }
      return t.apply(void 0, f(n));
    };
  },
  j = function () {
    return (typeof Headers === "undefined" ? "undefined" : l(Headers)) > "u" ? g : Headers;
  },
  P = function (e, t) {
    var n = I(t),
      i = j();
    return function () {
      var t = r(function (t, r) {
        var o, u;
        return p(this, function (c) {
          u = new i((o = r) === null || o === void 0 ? void 0 : o.headers);
          return [2, (u.has("X-MICROCMS-API-KEY") || u.set("X-MICROCMS-API-KEY", e), n(t, a(s({}, r), {
            headers: u
          })))];
        });
      });
      return function (e, n) {
        return t.apply(this, arguments);
      };
    }();
  };
import O from "async-retry";
var E = function (e) {
  var t = e.serviceDomain,
    n = e.apiKey,
    i = e.customFetch,
    o = e.retry;
  if (!t || !n) throw new Error("parameter is required (check serviceDomain and apiKey)");
  if (!v(t) || !v(n)) throw new Error("parameter is not string");
  var u = "https://".concat(t, ".").concat(b, "/api/").concat(w),
    c = function () {
      var e = r(function (e) {
        var t, c, f, l, d, h, y, v, b;
        return p(this, function (w) {
          switch (w.label) {
            case 0:
              t = e.endpoint, c = e.contentId, f = e.queries, l = f === void 0 ? {} : f, d = e.requestInit;
              h = P(n, i), y = m(l), v = "".concat(u, "/").concat(t).concat(c ? "/".concat(c) : "").concat(y ? "?".concat(y) : ""), b = function () {
                var e = r(function (e) {
                  var t, n, r;
                  return p(this, function (i) {
                    switch (i.label) {
                      case 0:
                        i.trys.push([0, 2,, 3]);
                        return [4, e.json()];
                      case 1:
                        t = i.sent(), n = t.message;
                        return [2, n !== null && n !== void 0 ? n : null];
                      case 2:
                        r = i.sent();
                        return [2, null];
                      case 3:
                        return [2];
                    }
                  });
                });
                return function t(t) {
                  return e.apply(this, arguments);
                };
              }();
              return [4, O(function () {
                var e = r(function (e) {
                  var t, n, r, i, o, u, c, f;
                  return p(this, function (l) {
                    switch (l.label) {
                      case 0:
                        l.trys.push([0, 6,, 7]);
                        return [4, h(v, a(s({}, d), {
                          method: (r = (t = d) === null || t === void 0 ? void 0 : t.method) !== null && r !== void 0 ? r : "GET"
                        }))];
                      case 1:
                        i = l.sent();
                        if (!(i.status !== 429 && i.status >= 400 && i.status < 500)) return [3, 3];
                        return [4, b(i)];
                      case 2:
                        o = l.sent();
                        return [2, e(new Error("fetch API response status: ".concat(i.status).concat(o ? "\n  message is `".concat(o, "`") : "")))];
                      case 3:
                        if (!!i.ok) return [3, 5];
                        return [4, b(i)];
                      case 4:
                        u = l.sent();
                        return [2, Promise.reject(new Error("fetch API response status: ".concat(i.status).concat(u ? "\n  message is `".concat(u, "`") : "")))];
                      case 5:
                        return [2, ((n = d) === null || n === void 0 ? void 0 : n.method) === "DELETE" ? void 0 : i.json()];
                      case 6:
                        c = l.sent();
                        if (c.data) throw c.data;
                        if ((f = c.response) === null || f === void 0 ? void 0 : f.data) throw c.response.data;
                        return [2, Promise.reject(new Error("Network Error.\n  Details: ".concat(c)))];
                      case 7:
                        return [2];
                    }
                  });
                });
                return function (t) {
                  return e.apply(this, arguments);
                };
              }(), {
                retries: o ? 2 : 0,
                onRetry: function (e, t) {
                  console.log(e), console.log("Waiting for retry (".concat(t, "/", 2, ")"));
                },
                minTimeout: 5e3
              })];
            case 1:
              return [2, w.sent()];
          }
        });
      });
      return function t(t) {
        return e.apply(this, arguments);
      };
    }();
  return {
    get: function () {
      var e = r(function (e) {
        var t, n, r, i, o, u;
        return p(this, function (s) {
          switch (s.label) {
            case 0:
              t = e.endpoint, n = e.contentId, r = e.queries, i = r === void 0 ? {} : r, o = e.customRequestInit;
              if (!t) return [3, 2];
              return [4, c({
                endpoint: t,
                contentId: n,
                queries: i,
                requestInit: o
              })];
            case 1:
              u = s.sent();
              return [3, 3];
            case 2:
              u = Promise.reject(new Error("endpoint is required"));
              s.label = 3;
            case 3:
              return [2, u];
          }
        });
      });
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
    getList: function () {
      var e = r(function (e) {
        var t, n, r, i, o;
        return p(this, function (u) {
          switch (u.label) {
            case 0:
              t = e.endpoint, n = e.queries, r = n === void 0 ? {} : n, i = e.customRequestInit;
              if (!t) return [3, 2];
              return [4, c({
                endpoint: t,
                queries: r,
                requestInit: i
              })];
            case 1:
              o = u.sent();
              return [3, 3];
            case 2:
              o = Promise.reject(new Error("endpoint is required"));
              u.label = 3;
            case 3:
              return [2, o];
          }
        });
      });
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
    getListDetail: function () {
      var e = r(function (e) {
        var t, n, r, i, o, u;
        return p(this, function (s) {
          switch (s.label) {
            case 0:
              t = e.endpoint, n = e.contentId, r = e.queries, i = r === void 0 ? {} : r, o = e.customRequestInit;
              if (!t) return [3, 2];
              return [4, c({
                endpoint: t,
                contentId: n,
                queries: i,
                requestInit: o
              })];
            case 1:
              u = s.sent();
              return [3, 3];
            case 2:
              u = Promise.reject(new Error("endpoint is required"));
              s.label = 3;
            case 3:
              return [2, u];
          }
        });
      });
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
    getObject: function () {
      var e = r(function (e) {
        var t, n, r, i, o;
        return p(this, function (u) {
          switch (u.label) {
            case 0:
              t = e.endpoint, n = e.queries, r = n === void 0 ? {} : n, i = e.customRequestInit;
              if (!t) return [3, 2];
              return [4, c({
                endpoint: t,
                queries: r,
                requestInit: i
              })];
            case 1:
              o = u.sent();
              return [3, 3];
            case 2:
              o = Promise.reject(new Error("endpoint is required"));
              u.label = 3;
            case 3:
              return [2, o];
          }
        });
      });
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
    getAllContentIds: function () {
      var e = r(function (e) {
        var t, n, r, i, o, u, l, d, h, y, v, m, b, w, q, g, I;
        return p(this, function (p) {
          switch (p.label) {
            case 0:
              t = e.endpoint, n = e.alternateField, r = e.draftKey, i = e.filters, o = e.orders, u = e.customRequestInit;
              l = {
                draftKey: r,
                filters: i,
                orders: o,
                limit: 100,
                fields: n !== null && n !== void 0 ? n : "id",
                depth: 0
              };
              return [4, c({
                endpoint: t,
                queries: a(s({}, l), {
                  limit: 0
                }),
                requestInit: u
              })];
            case 1:
              d = p.sent(), h = d.totalCount, y = [], v = 0, m = function (e) {
                return new Promise(function (t) {
                  return setTimeout(t, e);
                });
              }, b = function (e) {
                return e.every(function (e) {
                  return typeof e == "string";
                });
              };
              p.label = 2;
            case 2:
              if (!(y.length < h)) return [3, 7];
              return [4, c({
                endpoint: t,
                queries: a(s({}, l), {
                  offset: v
                }),
                requestInit: u
              })];
            case 3:
              w = p.sent(), q = w.contents, g = q.map(function (e) {
                return e[n !== null && n !== void 0 ? n : "id"];
              });
              if (!b(g)) throw new Error("The value of the field specified by `alternateField` is not a string.");
              y = f(y).concat(f(g)), v += 100;
              I = y.length < h;
              if (!I) return [3, 5];
              return [4, m(1e3)];
            case 4:
              I = p.sent();
              p.label = 5;
            case 5:
              I;
              p.label = 6;
            case 6:
              return [3, 2];
            case 7:
              return [2, y];
          }
        });
      });
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
    getAllContents: function () {
      var e = r(function (e) {
        var t, n, r, i, o, u, f, l, d, h, y, v;
        return p(this, function (p) {
          switch (p.label) {
            case 0:
              t = e.endpoint, n = e.queries, r = n === void 0 ? {} : n, i = e.customRequestInit;
              return [4, c({
                endpoint: t,
                queries: a(s({}, r), {
                  limit: 0
                }),
                requestInit: i
              })];
            case 1:
              o = p.sent(), u = o.totalCount, f = [], l = 0, d = function (e) {
                return new Promise(function (t) {
                  return setTimeout(t, e);
                });
              };
              p.label = 2;
            case 2:
              if (!(f.length < u)) return [3, 7];
              return [4, c({
                endpoint: t,
                queries: a(s({}, r), {
                  limit: 100,
                  offset: l
                }),
                requestInit: i
              })];
            case 3:
              h = p.sent(), y = h.contents;
              f = f.concat(y), l += 100;
              v = f.length < u;
              if (!v) return [3, 5];
              return [4, d(1e3)];
            case 4:
              v = p.sent();
              p.label = 5;
            case 5:
              v;
              p.label = 6;
            case 6:
              return [3, 2];
            case 7:
              return [2, f];
          }
        });
      });
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
    create: function () {
      var e = r(function (e) {
        var t, n, r, i, o, u, f, l;
        return p(this, function (d) {
          t = e.endpoint, n = e.contentId, r = e.content, i = e.isDraft, o = i === void 0 ? !1 : i, u = e.customRequestInit;
          if (!t) return [2, Promise.reject(new Error("endpoint is required"))];
          f = o ? {
            status: "draft"
          } : {}, l = a(s({}, u), {
            method: n ? "PUT" : "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(r)
          });
          return [2, c({
            endpoint: t,
            contentId: n,
            queries: f,
            requestInit: l
          })];
        });
      });
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
    update: function () {
      var e = r(function (e) {
        var t, n, r, i, o;
        return p(this, function (u) {
          t = e.endpoint, n = e.contentId, r = e.content, i = e.customRequestInit;
          if (!t) return [2, Promise.reject(new Error("endpoint is required"))];
          o = a(s({}, i), {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(r)
          });
          return [2, c({
            endpoint: t,
            contentId: n,
            requestInit: o
          })];
        });
      });
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
    delete: function () {
      var e = r(function (e) {
        var t, n, r, i;
        return p(this, function (o) {
          switch (o.label) {
            case 0:
              t = e.endpoint, n = e.contentId, r = e.customRequestInit;
              if (!t) return [2, Promise.reject(new Error("endpoint is required"))];
              if (!n) return [2, Promise.reject(new Error("contentId is required"))];
              i = a(s({}, r), {
                method: "DELETE",
                headers: {},
                body: void 0
              });
              return [4, c({
                endpoint: t,
                contentId: n,
                requestInit: i
              })];
            case 1:
              o.sent();
              return [2];
          }
        });
      });
      return function (t) {
        return e.apply(this, arguments);
      };
    }()
  };
};
export { E as createClient };